module.exports = __webpack_public_path__ + "static/media/product-1.26f1df70.jpg";